module.exports = {"TXTWCL_SorryX_you_must_verify_your_id_ELL":{"id":"TXTWCL_SorryX_you_must_verify_your_id_ELL","defaultMessage":"很抱歉，您必须先通过MitID验证身份才能继续。"}}